import React from 'react'
import { XIcon } from '@heroicons/react/outline'
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { authenticated } from '../recoil/auth';

const LogoutModal = (props) => {
  const setAuth = useSetRecoilState(authenticated);
  const navigate = useNavigate();

  const handleLogout = () => {
    setAuth({
      check: false,
      token: null,
      isExpired: false,
    });
    window.localStorage.removeItem('token');
    navigate("/");
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center w-screen min-h-screen bg-black bg-opacity-50">
        <div className="w-1/4 p-5 bg-white rounded-lg shadow">
            <div className="flex justify-between">
              <h3 className="text-lg font-semibold">Konfirmasi</h3>
              <XIcon className="w-5 h-5 cursor-pointer hover:text-blue-600" onClick={props.closeModal} />
            </div>
            <p className="my-5">Yakin ingin keluar akun?</p>
            <div className="flex items-center justify-center gap-3">
                <button type="button" onClick={handleLogout} className="px-5 py-3 text-sm text-white bg-red-500 rounded-lg shadow hover:bg-red-600 shadow-blue-100">Yakin</button>
                <button type="button" onClick={props.closeModal} className="px-5 py-3 text-sm rounded-lg shadow bg-slate-50 hover:bg-slate-100 shadow-blue-100">Batal</button>
            </div>
        </div>
    </div>
  )
}

export default LogoutModal